const API_ERROR_EVENT = "valitan:api-error-change";
let apiErrorState = null;

export const getApiErrorState = () => {
  return apiErrorState;
};

const emitApiErrorStateChange = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(API_ERROR_EVENT));
};

export const setApiErrorState = (payload) => {
  apiErrorState = payload;
  emitApiErrorStateChange();
};

export const clearApiErrorState = () => {
  apiErrorState = null;
  emitApiErrorStateChange();
};

export const subscribeToApiErrorState = (callback) => {
  if (typeof window === "undefined") return () => {};

  window.addEventListener(API_ERROR_EVENT, callback);
  return () => window.removeEventListener(API_ERROR_EVENT, callback);
};
